import { BrandSymbol } from "../shared/Brand.js";
import type { ReactNode } from "react";
import { t } from "../shared/i18n.js";
import { Icon } from "../shared/Icon.js";
import { WorkspaceMenu } from "../shared/ui/WorkspaceMenu.js";
import { Link } from "./router.js";
import { TABS } from "./spaces.js";

/**
 * La coquille des destinations (audit §4.2) : Vidéos · ＋ · Idées, comme Edits / VN — la création au centre,
 * l'accueil c'est « mes vidéos ». Barre d'onglets en bas sur téléphone, rail à gauche sur ordinateur. Les
 * réglages (et la Bibliothèque) passent par l'avatar. Un projet ouvert n'a pas de coquille : il garde l'écran.
 */
export function Shell({ path, children }: { path: string; children: ReactNode }) {
  const tab = (x: (typeof TABS)[number]) => (
    <Link key={x.to} className="tab" to={x.to} aria-current={path === x.to ? "page" : undefined} data-testid={x.testId}>
      <Icon name={x.icon} />
      <span>{t(x.label)}</span>
    </Link>
  );
  return (
    <div className="shell">
      <nav className="siderail" aria-label={t("nav.label")}>
        <Link className="logo" to="/" aria-label="editit">
          <BrandSymbol reveal /> EditIT
        </Link>
        <Link className="btn primary rail-new" to="/nouveau" data-testid="new-project">
          <Icon name="plus" size="sm" />
          {t("nav.new")}
        </Link>
        {TABS.map(tab)}
        <span className="grow" />
        <WorkspaceMenu place="rail" />
      </nav>
      <div className="shell-main">{children}</div>
      <nav className="tabbar" aria-label={t("nav.label")}>
        {tab(TABS[0])}
        <Link className="tab-new" to="/nouveau" aria-label={t("nav.new")} data-testid="new-project-tab">
          <Icon name="plus" />
        </Link>
        {TABS.slice(1).map(tab)}
      </nav>
    </div>
  );
}
